import { updateCounsilors } from "api/counsilors";
import DeleteQualification from "components/Modal/DeleteQualification";
import Education from "components/Modal/Education";
import Experience from "components/Modal/Experience";
import {
  setEditQualification,
  setExpChangeLoading,
} from "pages/Councillors/counsilorSlice";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Initiatives from "./Initiatives";

import {
  AddIcon,
  AddIconWithCircle,
  DeleteIcon,
  EditIcon,
  EducationIcon,
  ExperienceIcon,
} from "themes/Icon";
import { isPermit } from "utils/permissionCheck";
import style from "./right_section.module.scss";

function RightSection({ fetchCouncillor }) {
  const { selectedCounsilor } = useSelector((state) => state.counsilor);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [experienceOpen, setExperienceOpen] = useState(false);
  const [educationOpen, setEducationOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [seletedItem, setSelectedItem] = useState(null);

  const handleSave = async (action, item, typeOfQualification) => {
    dispatch(setExpChangeLoading(true));
    const experienceData = {
      startDate: item.startDate,
      endDate: item.endDate,
      qualificationName: item.title,
      authorityName: item.subTitle,
      action,
      typeOfQualification,
      councilorId: selectedCounsilor?.councilor_id,
    };

    if (action === "update") {
      experienceData.recordId = item?.recordId;
    }

    try {
      const response = await updateCounsilors(experienceData);
      if (response) {
        fetchCouncillor();
        toast.success(response.message);
        if (typeOfQualification === "experience") {
          setExperienceOpen(false);
        } else if (typeOfQualification === "education") {
          setEducationOpen(false);
        }
        dispatch(setExpChangeLoading(false));
      } else {
        dispatch(setExpChangeLoading(false));
      }
    } catch (error) {
      dispatch(setExpChangeLoading(false));
    }
  };

  const handleDelete = async (item, typeOfQualification) => {
    dispatch(setExpChangeLoading(true));
    const experienceData = {
      startDate: item?.exp_start_date || item?.edu_start_date,
      endDate: item?.exp_end_date || item?.edu_end_date,
      qualificationName: item?.title || item?.course_name,
      authorityName: item.sub_title || item?.board_name,
      action: "delete",
      typeOfQualification,
      councilorId: selectedCounsilor?.councilor_id,
      recordId: item?.councilor_exp_info_id || item?.councilor_edu_info_id,
    };

    try {
      const response = await updateCounsilors(experienceData);
      if (response) {
        fetchCouncillor();
        toast.success(response.message);
        setIsDelete(false);
        dispatch(setExpChangeLoading(false));
      } else {
        dispatch(setExpChangeLoading(false));
      }
    } catch (error) {
      dispatch(setExpChangeLoading(false));
    }
  };

  // Separate rendering logic for Experience and Education
  const renderSection = (section, setOpen, type) => (
    <>
      {section.items.map((item, idx) => (
        <div key={idx} className={style["resume-item"]}>
          <div className="flex justify-between">
            <h4 className={style["item-title"]}>
              {item.title || item.course_name}
            </h4>
            <p className={style["item-years"]}>
              {item.period || item.period_year}
            </p>
          </div>
          <p className={style["item-company"]}>
            {item.sub_title || item.board_name}
          </p>
          {/* <p className={style["item-details"]}>
            {item.period || item.period_year}
          </p> */}

          {item.description && (
            <ul className={style["item-description"]}>
              {item.description?.map((desc, descIdx) => (
                <li key={descIdx}>{desc}</li>
              ))}
            </ul>
          )}
          {isPermit(7, "edit") && (
            <button
              onClick={() => {
                setSelectedItem({ item, qualificationType: type }); // Assigning type as 'delete'
                setIsEdit(false);
                setIsDelete(true);
              }}
              className={style["dlt-btn"]}
            >
              <DeleteIcon />
            </button>
          )}
          {isPermit(7, "edit") && (
            <span
              onClick={() => {
                dispatch(setEditQualification(true));
                setSelectedItem(item);
                setIsEdit(true);
                setOpen(true);
              }}
              className={style["edit-btn"]}
            >
              <EditIcon />
            </span>
          )}
        </div>
      ))}
    </>
  );

  return (
    <>
      <div className={style["section-container"]}>
        <div className={style["resume-section"]}>
          <div className="flex align-center justify-between">
            <div className="flex align-center gap-2">
              <span>
                <ExperienceIcon />
              </span>
              <h4 className={style["section-title"]}>Experience</h4>
            </div>
            {isPermit(7, "edit") &&
              selectedCounsilor?.experience?.length > 0 && (
                <button
                  onClick={() => {
                    dispatch(setEditQualification(false));
                    setIsEdit(false);
                    setExperienceOpen(true);
                  }}
                  className={style["add-btn"]}
                >
                  <AddIconWithCircle /> Add
                </button>
              )}
          </div>
          {selectedCounsilor?.experience?.length > 0 ? (
            renderSection(
              { items: selectedCounsilor.experience },
              setExperienceOpen,
              "exp"
            )
          ) : (
            <>
              {isPermit(7, "edit") && (
                <button
                  onClick={() => {
                    dispatch(setEditQualification(false));
                    setIsEdit(false);
                    setExperienceOpen(true);
                  }}
                  className={style["empty-state"]}
                >
                  <AddIcon />
                  Click to add
                </button>
              )}
            </>
          )}
        </div>
        <div className={style["resume-section"]}>
          <div className="flex align-center justify-between">
            <div className="flex align-center gap-2">
              <span>
                <EducationIcon />
              </span>
              <h4 className={style["section-title"]}>Education</h4>
            </div>
            {isPermit(7, "edit") &&
              selectedCounsilor?.education?.length > 0 && (
                <button
                  onClick={() => {
                    dispatch(setEditQualification(false));

                    setIsEdit(false);
                    setEducationOpen(true);
                  }}
                  className={style["add-btn"]}
                >
                  <span className="">
                    <AddIcon />
                  </span>
                  Add
                </button>
              )}
          </div>
          {selectedCounsilor?.education?.length > 0 ? (
            renderSection(
              { items: selectedCounsilor?.education },
              setEducationOpen,
              "edu"
            )
          ) : (
            <>
              {isPermit(7, "edit") && (
                <button
                  onClick={() => {
                    dispatch(setEditQualification(false));
                    setIsEdit(false);
                    setEducationOpen(true);
                  }}
                  className={style["empty-state"]}
                >
                  <AddIcon />
                  Click to add
                </button>
              )}
            </>
          )}
        </div>
        <Initiatives />
      </div>
      <Experience
        isEdit={isEdit}
        seletedItem={seletedItem}
        open={experienceOpen}
        setOpen={setExperienceOpen}
        handleSave={handleSave}
      />
      <Education
        isEdit={isEdit}
        seletedItem={seletedItem}
        open={educationOpen}
        setOpen={setEducationOpen}
        handleSave={handleSave}
      />

      <DeleteQualification
        isOpen={isDelete}
        setOpen={setIsDelete}
        selectedData={seletedItem}
        data={seletedItem}
        handleDeleteQualification={handleDelete}
      />
    </>
  );
}

export default RightSection;
